import { useRequest } from 'src/lib/hooks'

import { CommunityEndpoints } from '../../constants'
import CommunityService from '../../service'

const useGetCommunity = (communityId?: number) => {
  const {
    data: communityData,
    isRefetching,
    isInitialLoading: isLoadingCommunityData,
    invalidate: invalidateCommunityData,
    refetch,
    isError
  } = useRequest(
    [CommunityEndpoints.getCommunity(Number(communityId))],
    () => CommunityService.getCommunity(communityId),
    { enabled: Boolean(communityId) }
  )

  return {
    communityData,
    isError,
    refetch,
    isRefetching,
    isLoadingCommunityData,
    invalidateCommunityData
  }
}

export default useGetCommunity
